import React from "react";
import BigValueFormatter from "../../utils/bigNumbers";
import BigValueFormatterWOsign from "../../utils/bigNumbersWOsign";

const InfoBlock = ({ totalMarketCapUsd, totalCount }) => {
  return (
    <div className="relative overflow-hidden rounded-xl border border-neutral-20 bg-neutral-0 dark:border-neutral-95 dark:bg-neutral-95 shadow-black-5 transition-all duration-200 dark:shadow-black-40 h-full w-full px-3 py-3 sm:px-4 sm:py-4">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col">
          <div className="flex flex-col">
            <h1 className="min-w-0 flex-grow truncate text-sm font-semibold text-neutral-100 transition-colors dark:text-neutral-0">
              CoinsCheck Blockchain Security Audit
            </h1>
            <div className="my-3 grid grid-cols-2 gap-3">
              <div className="flex flex-col gap-1">
                <span className="text-xl font-semibold text-neutral-100 dark:text-neutral-0">
                  <BigValueFormatter value={totalMarketCapUsd} />
                </span>
                <span className="truncate text-xs font-medium text-neutral-40 dark:text-neutral-60">
                  Market Cap Assessed
                </span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-xl font-semibold text-neutral-100 dark:text-neutral-0">
                  <BigValueFormatterWOsign value={totalCount} />
                </span>
                <span className="truncate text-xs font-medium text-neutral-40 dark:text-neutral-60">
                  Projects Audited
                </span>
              </div>
            </div>
          </div>
          <button
            type="button"
            className="box-border flex items-center justify-center whitespace-nowrap rounded-lg font-semibold transition-bg-colors focus-visible:outline-none focus-visible:ring gap-2 text-sm w-full h-8 px-2.5 bg-neutral-100 dark:brightness-90 text-neutral-0 hover:bg-neutral-70 focus-visible:ring-secondary-focus active:bg-neutral-50 dark:text-neutral-100 dark:bg-neutral-0 dark:hover:bg-neutral-30 dark:active:bg-neutral-50 dark:focus-visible:ring-secondary-focus-dark"
          >
            Request CoinsCheck Audit
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoBlock;
